import * as yup from 'yup';
import { confirmPassword, password, TranslateFn } from '../../../library/validationRules';
import { AccountMode } from '../../../library/models/publicBooking';
import ResourcesIds from '../../../resources/ResourcesIds';

export interface VerifyBookingValues {
    password: string;
    confirmPassword: string;
}

/**
 * A password being chosen is checked for length and typed twice; one being entered is whatever
 * its owner picked, possibly before today's rule, and is only required. The confirmation rule is
 * removed rather than hidden for an existing account -- a rule no field shows would leave the
 * button doing nothing.
 */
export const createVerifyBookingSchema = (translate: TranslateFn, mode: AccountMode) =>
    mode === 'CHOOSE_PASSWORD'
        ? yup.object({
            password: password(translate),
            confirmPassword: confirmPassword(translate, 'password'),
        })
        : yup.object({
            password: yup.string().required(translate(ResourcesIds.PASSWORD_REQUIRED)),
            confirmPassword: yup.string().defined(),
        });
